import React, { PropsWithChildren } from 'react';
import theme from './ProductCard.module.scss';
import { classnames } from '@ygtechnologies/bygr-frontend-component-library';

export interface ProductCardListProps extends PropsWithChildren {
    singleColumn?: boolean;
    /** Remove the outer padding and inter-item gap so the cards tile flush (used in the showroom). */
    compact?: boolean;
    /** Two-tier configurator menu: switch to two columns on the group-list viewport breakpoint
     *  (portrait tablets) instead of the default 1000px container query. */
    menuColumns?: boolean;
}

export const ProductCardList: React.FC<ProductCardListProps> = ({ children, singleColumn, compact, menuColumns }) => {
    return (
        <div
            className={classnames(theme.cardList, {
                [theme.singleColumn]: singleColumn,
                [theme.compact]: compact,
                [theme.menuColumns]: menuColumns,
            })}>
            <div>{children}</div>
        </div>
    );
};
